import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a-modal', {
    attrs: {
      "title": "发送工资条",
      "width": 600,
      "maskClosable": false
    },
    on: {
      "ok": _vm.handleOk,
      "cancel": _vm.handleCancel
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "send-range-section"
  }, [_c('h4', [_vm._v("发送范围")]), _c('a-radio-group', {
    staticStyle: {
      "margin-top": "8px"
    },
    model: {
      value: _vm.selectedRange,
      callback: function callback($$v) {
        _vm.selectedRange = $$v;
      },
      expression: "selectedRange"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("全部人员（" + _vm._s(_vm.totalRecords) + "人）")]), _c('a-radio', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("仅待发送人员（" + _vm._s(_vm.pendingSendRecords) + "人）")]), _c('a-radio', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("选择人员")])], 1), _vm.selectedRange === 3 ? _c('div', {
    staticClass: "select-person-container",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "person-list",
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto",
      "margin-top": "10px",
      "border": "1px solid #ddd",
      "padding": "10px"
    }
  }, [_c('a-checkbox-group', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column"
    },
    model: {
      value: _vm.selectedPersons,
      callback: function callback($$v) {
        _vm.selectedPersons = $$v;
      },
      expression: "selectedPersons"
    }
  }, _vm._l(_vm.availablePersons, function (person) {
    return _c('a-checkbox', {
      key: person.id,
      attrs: {
        "value": person.id
      }
    }, [_vm._v(" " + _vm._s(person.name) + " (" + _vm._s(person.jobNumber) + ") ")]);
  }), 1)], 1)]) : _vm._e()], 1), _c('div', {
    staticClass: "warning-message",
    staticStyle: {
      "margin-top": "20px",
      "padding": "10px",
      "background-color": "#fffbe6",
      "border": "1px solid #ffe58f",
      "border-radius": "4px"
    }
  }, [_c('p', [_vm._v("工资条将通过系统内通知发送给选中的教职工，已发送的记录将被重新发送。")])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };